"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZoneFile = void 0;

var _makeZoneFile = require("./makeZoneFile");

var _parseZoneFile = require("./parseZoneFile");

var ZoneFile =
/*#__PURE__*/
function () {
  function ZoneFile(zoneFile) {
    _classCallCheck(this, ZoneFile);

    if (typeof zoneFile === 'object') {
      this.jsonZoneFile = JSON.parse(JSON.stringify(zoneFile));
    } else if (typeof zoneFile === 'string') {
      this.jsonZoneFile = (0, _parseZoneFile.parseZoneFile)(zoneFile);
    }
  }

  _createClass(ZoneFile, [{
    key: "toJSON",
    value: function toJSON() {
      return this.jsonZoneFile;
    }
  }, {
    key: "toString",
    value: function toString() {
      return (0, _makeZoneFile.makeZoneFile)(this.toJSON());
    }
  }]);

  return ZoneFile;
}();

exports.ZoneFile = ZoneFile;